import script from "./ManageStudentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageStudentsView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__